export default "__VITE_ASSET__dad2175c__"